var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2692 8.30769H10.231V0.692308C10.231 0.508696 10.154 0.332605 10.017 0.202772C9.87992 0.0729395 9.69405 0 9.50024 0C9.30643 0 9.12056 0.0729395 8.98352 0.202772C8.84648 0.332605 8.76949 0.508696 8.76949 0.692308V8.30769H0.73123C0.537422 8.30769 0.351553 8.38063 0.214511 8.51046C0.0774686 8.6403 0.000478848 8.81639 0.000478848 9C-0.00312714 9.08998 0.0136666 9.17964 0.049728 9.26295C0.0857893 9.34625 0.14028 9.42127 0.20953 9.48294C0.278779 9.54461 0.361176 9.5915 0.45117 9.62045C0.541164 9.6494 0.636662 9.65974 0.73123 9.65077H8.76949V17.3077C8.76949 17.4913 8.84648 17.6674 8.98352 17.7972C9.12056 17.9271 9.30643 18 9.50024 18C9.69405 18 9.87992 17.9271 10.017 17.7972C10.154 17.6674 10.231 17.4913 10.231 17.3077V9.69231H18.2692C18.4631 9.69231 18.6489 9.61937 18.786 9.48954C18.923 9.3597 19 9.18361 19 9C19 8.81639 18.923 8.6403 18.786 8.51046C18.6489 8.38063 18.4631 8.30769 18.2692 8.30769Z",
    fill: "#CD8F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.051b41b5b2eb8e27a65ec65a16b2df8c.svg";
export { ForwardRef as ReactComponent };